import { Card } from '../../model/Card';
import gameStore from '../../store/GameStore';
import playerStore from '../../store/PlayerStore';
import { WEvent } from './WEvent';

export class WPlayerInitCardsEvent extends WEvent {
  gameId: string;
  pid: string;
  cards: Card[];

  constructor(event: WPlayerInitCardsEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    gameStore.findActiveGame(this.tableId).then(game => {
      game.setPlayers(
        playerStore.modifyPlayers(game.players, this.pid, player => {
          player.cards = this.cards;
          player.notParticipating = false;
        }),
      );
    });
}
